import ThemedItem from './themed-item';

import {
	createAndFireNavigationEvent,
	withAnalyticsEvents,
	UI_EVENT_TYPE,
	SWITCHER_ITEM_SUBJECT,
} from '../../common/utils/analytics';
import { type SwitcherItemProps } from './item';
import { type UIAnalyticsEvent } from '@atlaskit/analytics-next';

type Props = Omit<SwitcherItemProps, 'onClick'> & {
	onClick?: (event: React.SyntheticEvent, analyticsEvent: UIAnalyticsEvent) => void;
};
//error TS2347: Untyped function calls may not accept type arguments.
//@ts-ignore TypeScript 4.2.4 upgrade
const SwitcherItemWithEvents = withAnalyticsEvents({
	onClick: createAndFireNavigationEvent({
		eventType: UI_EVENT_TYPE,
		action: 'clicked',
		actionSubject: SWITCHER_ITEM_SUBJECT,
	}),
})<Props, typeof ThemedItem>(ThemedItem as any);

export default SwitcherItemWithEvents;
